export default class Student {
    constructor(options) {
      Object.assign(this, options)
    }
  
    toSend() {
      return {
        studentId: this.id,
        userProfile: this.mapUserProfile(this.userProfile),
        type: this.type,
        //universityId: this.universityToApply.id,
        //careerId: (this.careerToApply) ? this.careerToApply.id : null,
        highSchoolId: (this.highSchool) ? this.highSchool.id : null,
        homePhone: this.homePhone,
        cellPhone: this.cellPhone,
        about: this.about,
        homeAddress: this.homeAddress,
        hasDiseaseOrSpecialCondition: this.hasDiseaseOrSpecialCondition,
        pageUrlFacebook: this.pageUrlFacebook,
        pageUrlInstagram: this.pageUrlInstagram,
        selectedCareerObservation: this.selectedCareerObservation,
        advisoryObservation: this.advisoryObservation,
        subjectComplicationObservation: this.subjectComplicationObservation,
        universitiesToApply: this.universitiesToApply,
        careers: this.careers.map((item) => item),
      }
    }

    mapUserProfile(data) {
      return {
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email,
        status: data.status,
        userName: data.userName,
        password: data.password,
        // El backend resuelve el usuario propietario desde el StudentId; aquí sólo viaja el rol.
        roleId: (data.role && data.role.id) ? data.role.id : null,
      }
    }

    toSendStudentInfo() {
      return {
        highSchoolId: this.highSchool.id,
        careers: this.collection.map((item) => item),
        hasDiseaseOrSpecialCondition: this.hasDiseaseOrSpecialCondition,
        selectedCareerObservation: this.selectedCareerObservation,
        advisoryObservation: this.advisoryObservation,
        subjectComplicationObservation: this.subjectComplicationObservation,
        about: this.about,
        homeAddress: this.homeAddress,
      }
    }

  }